import React, { memo, useCallback, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames/bind';
import { noop } from '../utils/noop';
import { Overlay } from '../overlay';
import { Portal } from '../portal';
import { KEY_CODES } from '../key-codes';
import style from '../overlay/overlay.module.scss';
import { ModalView } from './_components/modal-view';
import { OVERLAY_TIMEOUT, MODAL_VARIANT } from './constants';
var cn = classNames.bind(style);
export var Modal = memo(function (_a) {
    var actionsConfig = _a.actionsConfig, children = _a.children, disableOverlayClick = _a.disableOverlayClick, isDarkTheme = _a.isDarkTheme, isExitAnimationDisabled = _a.isExitAnimationDisabled, isFullScreen = _a.isFullScreen, isOpened = _a.isOpened, isShowCloseIcon = _a.isShowCloseIcon, isTransparent = _a.isTransparent, noPadding = _a.noPadding, _b = _a.onClose, onClose = _b === void 0 ? noop : _b, _c = _a.size, size = _c === void 0 ? 's' : _c, title = _a.title, _d = _a.titleSize, titleSize = _d === void 0 ? 'h1' : _d, _e = _a.variant, variant = _e === void 0 ? MODAL_VARIANT.CENTER : _e, _f = _a.zIndex, zIndex = _f === void 0 ? 99 : _f, _g = _a.portalPrefix, portalPrefix = _g === void 0 ? 'modal' : _g;
    var handleOverlayClick = useCallback(function (event) {
        // needs to verify click on overlay element
        if (event.target === event.currentTarget && !disableOverlayClick) {
            onClose();
        }
    }, [disableOverlayClick, onClose]);
    var handleDocumentKeyDown = useCallback(function (_a) {
        var keyCode = _a.keyCode;
        if (keyCode === KEY_CODES.ESCAPE) {
            onClose();
        }
    }, [onClose]);
    useEffect(function () {
        window.addEventListener('keydown', handleDocumentKeyDown);
        return function () {
            window.removeEventListener('keydown', handleDocumentKeyDown);
        };
    }, []); // eslint-disable-line
    return (React.createElement(Portal, { "data-name": "Modal", prefix: portalPrefix, zIndex: zIndex },
        variant === MODAL_VARIANT.CENTER && (React.createElement(Overlay, { isExitAnimationDisabled: isExitAnimationDisabled, onClick: handleOverlayClick, opened: isOpened, timeout: OVERLAY_TIMEOUT, transparent: isTransparent },
            React.createElement(ModalView, { actionsConfig: actionsConfig, isDarkTheme: isDarkTheme, isFullScreen: isFullScreen, isShowCloseIcon: isShowCloseIcon, noPadding: noPadding, onClose: onClose, size: size, title: title, titleSize: titleSize }, children))),
        variant === MODAL_VARIANT.BOTTOM && (React.createElement(CSSTransition, { classNames: {
                enter: cn('Overlay--enter'),
                exit: cn(isExitAnimationDisabled ? '' : 'Overlay--exit'),
            }, "data-name": "Overlay", in: isOpened, timeout: OVERLAY_TIMEOUT, unmountOnExit: true },
            React.createElement(ModalView, { actionsConfig: actionsConfig, isDarkTheme: isDarkTheme, isShowCloseIcon: isShowCloseIcon, noPadding: noPadding, onClose: onClose, size: size, title: title, titleSize: titleSize, variant: variant }, children)))));
});
